import { Trans } from "react-i18next"
import type { TFunction } from "react-i18next"
import { BadgeStateItem } from "./types"
import { Badge, BadgeProps } from "@oysterhr/ui"

interface Props {
  data: Array<BadgeStateItem>
  t: TFunction
  badgeProps?: Partial<BadgeProps>
}

const StatesDescription = ({ data, badgeProps, t }: Props) => (
  <table>
    <tbody>
      {data.map(state => (
        <tr key={state.translationKey}>
          <td className="py-5 pr-3">
            <Badge variation={state.variation} className="whitespace-nowrap" {...badgeProps}>
              {t(state.translationKey)}
            </Badge>
          </td>
          <td className="py-5">
            <p className="leading-5">
              <Trans
                defaults={t(state.descriptionKey)}
                components={{ b: <span className="font-semibold" /> }}
              />
            </p>
          </td>
        </tr>
      ))}
    </tbody>
  </table>
)

export { StatesDescription }
